import { RemoveSubModelMessage } from "flavr-common";
import { ModelClickedMessage, ModelHoverMessage, ModelTouchMessage } from "../../../messages/interaction/InteractionMessages";
import { Vector3 } from "flavr-math";
import { busService } from "../../bus/BusService";
const tmpVector3One = new Vector3();
const tmpVector3Two = new Vector3();
class InputEventService {
    constructor() {
        this.modelsCallbacks = new Map();
        this.handleModelClickedMessage = (msg) => {
            const model = this.modelsCallbacks.get(msg.uid);
            if (model === undefined)
                return;
            tmpVector3One.fromArray(msg.hitPoint);
            tmpVector3Two.fromArray(msg.localPoint);
            for (const delegates of model.values()) {
                if (delegates.onClick === undefined)
                    continue;
                delegates.onClick(tmpVector3One, tmpVector3Two, msg.controllerUid);
            }
        };
        this.handleModelHoverMessage = (msg) => {
            const model = this.modelsCallbacks.get(msg.uid);
            if (model === undefined)
                return;
            tmpVector3One.fromArray(msg.hitPoint);
            for (const delegates of model.values()) {
                if (delegates.onHover === undefined)
                    continue;
                delegates.onHover(tmpVector3One, msg.controllerUid);
            }
        };
        this.handleModelTouchMessage = (msg) => {
            const model = this.modelsCallbacks.get(msg.uid);
            if (model === undefined)
                return;
            tmpVector3Two.fromArray(msg.currHitPoint);
            for (const delegates of model.values()) {
                if (delegates.onTouch === undefined)
                    continue;
                delegates.onTouch(msg.state, tmpVector3Two, msg.controllerUid);
            }
        };
        this.handleRemoveSubModelMessage = (msg, meta) => {
            const model = this.modelsCallbacks.get(msg.uid);
            if (model === undefined)
                return;
            for (const [type, callback] of model) {
                if (callback.createdTime > meta.timeStamp)
                    continue;
                model.delete(type);
            }
            if (this.modelsCallbacks.size === 0) {
                this.modelsCallbacks.delete(msg.uid);
            }
        };
        const connection = busService.connection("InputEventService");
        connection.subscribeByType(ModelClickedMessage, this.handleModelClickedMessage);
        connection.subscribeByType(ModelHoverMessage, this.handleModelHoverMessage);
        connection.subscribeByType(ModelTouchMessage, this.handleModelTouchMessage);
        connection.subscribeByType(RemoveSubModelMessage, this.handleRemoveSubModelMessage);
    }
    register(uid, type, onClick, onHover, onTouch, timestamp) {
        let model = this.modelsCallbacks.get(uid);
        if (model === undefined) {
            model = new Map();
            this.modelsCallbacks.set(uid, model);
        }
        model.set(type, {
            createdTime: timestamp === undefined ? Date.now() : timestamp,
            onClick,
            onHover,
            onTouch
        });
    }
    unregister(uid, type) {
        const model = this.modelsCallbacks.get(uid);
        if (model === undefined)
            return;
        model.delete(type);
        if (model.size === 0) {
            this.modelsCallbacks.delete(uid);
        }
    }
}
const inputEventService = new InputEventService();
export { inputEventService };
